/**
 * Prevent open redirects: only same-site paths we explicitly allow.
 * @param {string | null | undefined} raw - from ?next= query
 * @returns {string | null} path starting with / or null
 */
const ALLOWED = new Set([
    '/',
    '/cart',
    '/checkout',
    '/checkout/success',
    '/account',
    '/login',
    '/register',
]);

export function getSafeRedirectPath(raw) {
    if (raw == null || typeof raw !== 'string') return null;
    const t = raw.trim();
    if (!t.startsWith('/') || t.startsWith('//')) return null;
    const pathOnly = t.split('?')[0].split('#')[0];
    if (!pathOnly || !ALLOWED.has(pathOnly)) return null;
    return pathOnly;
}

export function buildLoginUrl(nextPath) {
    const safe = getSafeRedirectPath(nextPath);
    return safe ? `/login?next=${encodeURIComponent(safe)}` : '/login';
}

export function buildRegisterUrl(nextPath) {
    const safe = getSafeRedirectPath(nextPath);
    return safe ? `/register?next=${encodeURIComponent(safe)}` : '/register';
}
